import { Link } from "react-router";

import { Box, BoxProps, Flex } from "@/components/layout/flexbox";
import { Avatar } from "@/components/pieces/users/Avatar";
import { CARD_CLASSES } from "@/css/constants";
import { CoachingCurrentUser, CoachingCustomer } from "@/types/users";

interface MiniProfileProps extends BoxProps {
  user: CoachingCurrentUser | CoachingCustomer;
}

export function MiniProfile({ user, ...props }: MiniProfileProps) {
  if (!("agentProfile" in user) || !user.agentProfile) return null;
  return (
    <Flex
      className={CARD_CLASSES}
      backgroundColor="#FFF"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      p={3}
      {...props}
    >
      <Flex alignItems="center" fontWeight={500}>
        <Avatar size={32} user={user} />
        <Box ml={2}>{user.name}</Box>
      </Flex>
      <Link to={`/@${user.agentProfile?.coachSlug}`}>View Profile</Link>
    </Flex>
  );
}
